<template>
  <b-modal
      v-bind="$props"
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <div class="text-center py-2">
      <div class="d-flex justify-content-center mb-3">
        <img :src="AlertIcon" alt="Alert Icon" width="40" height="40" />
      </div>
      <h4>{{ dialogTitle }}</h4>
      <p class="m-0 text-muted">{{ dialogDescription }}</p>
    </div>
    <template #modal-footer>
      <b-button
          class="w-100 m-0"
          variant="light"
          @click="hide"
      >
        {{ $t('Close') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from '@/components/modals/confirmation-modal.vue'
import AlertIcon from '@/assets/icons/AlertIcon.svg'

export default {
  name: 'purchase-plan-publish-limit-dialog',
  extends: ConfirmationModal,
  props: {
    id: {default: 'purchase-plan-publish-limit-dialog-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      AlertIcon,
      planId: '',
    };
  },
  computed: {
    dialogTitle() {
      const id = `${this.planId ?? ''}`.trim()

      return id
          ? this.$t('purchase_plans.modal_messages.publish_limit_exceeded_title', {id})
          : this.$t('purchase_plans.modal_messages.publish_limit_exceeded_title_no_id')
    },
    dialogDescription() {
      return this.$t('purchase_plans.modal_messages.publish_limit_exceeded_description')
    },
  },
  methods: {
    show(planId = '') {
      this.planId = planId
      this.$bvModal.show(this.id)
    },
    hide() {
      this.$bvModal.hide(this.id)
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }
}
</style>
